<template>
    <div class="device-list-container">
        <!-- 页面标题 -->
        <!-- <div class="page-header">
      <h2>模板管理</h2>
      <p>管理所有物联网模板及相关信息</p>
    </div> -->

        <el-card class="main-card">
            <div slot="header" class="card-header">
                <div class="header-actions">
                    <span class="card-title">模板列表</span>
                    <el-button type="primary" icon="el-icon-plus" @click="handleAddDevice" class="add-btn">
                        添加模板
                    </el-button>
                </div>
            </div>

            <!-- 搜索区域 -->
            <div class="filter-bar">
                模板名称：<el-input placeholder="请输入模板名称" style="margin-right: 20px;" v-model="searchKeyword"
                    prefix-icon="el-icon-search" class="search-input" @input="handleSearch"></el-input>
                <!-- 模板ID：<el-input placeholder="请输入模板编码" v-model="searchKeywordCode" prefix-icon="el-icon-search"
                    class="search-input" @input="handleSearch"></el-input> -->
            </div>

            <!-- 模板表格 -->
            <el-table :data="devices" border class="device-table" stripe highlight-current-row
                :row-class-name="tableRowClassName">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="templateCode" label="模板编码"></el-table-column>
                <!-- <el-table-column prop="code" label="模板编码" width="230"></el-table-column> -->
                <el-table-column prop="templateName" label="模板名称"></el-table-column>
                <el-table-column prop="createTime" label="模板创建时间"></el-table-column>
                <el-table-column prop="updateTime" label="模板更新时间"></el-table-column>
                <el-table-column prop="enable" label="是否启用">
                    <template slot-scope="scope">
                        <span>{{ scope.row.enable == 0 ? '禁用' : '启用' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="240">
                    <template slot-scope="scope">

                        <el-button size="mini" type="text" @click="handleViewOpen(scope.row.id)"
                            class="operation-btn view-btn">
                            启用
                        </el-button>
                        <el-button size="mini" type="text" @click="handleViewdisable(scope.row.id)"
                            class="operation-btn view-btn">
                            禁用
                        </el-button>

                        <el-button size="mini" type="text" @click="handleEditDevice(scope.row)"
                            class="operation-btn edit-btn">
                            编辑
                        </el-button>
                        <el-button size="mini" type="text" @click="handleDeleteDevice(scope.row.id)"
                            class="operation-btn delete-btn">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total" class="pagination"></el-pagination>
            </div>
        </el-card>

        <!-- 新增模板信息弹窗 -->
        <el-dialog title="新增模板信息" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false"
            :destroy-on-close="true" custom-class="custom-dialog">
            <el-form ref="deviceForm" :model="deviceForm" :rules="rules" label-width="120px" class="device-form">
                <!-- 设备类型 -->
                <el-form-item label="设备类型" prop="type">
                    <el-select v-model="deviceForm.type" placeholder="请选择设备类型" clearable class="form-select"
                        @change="handleChangeName">
                        <el-option v-for="item in deviceequipmentTypes" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="模板名称" prop="templateName">
                    <el-input v-model="deviceForm.templateName" placeholder="请输入模板名称" maxlength="50" show-word-limit
                        class="form-input"></el-input>
                </el-form-item>


                <!-- 模板是否启用 -->
                <el-form-item label="是否启用" prop="type">
                    <el-radio v-model="radio" label="1">启用</el-radio>
                    <el-radio v-model="radio" label="0">禁用</el-radio>
                </el-form-item>
                <el-form-item label="传感器" required>
                    <el-checkbox-group v-model="selectedIds">
                        <!-- <div class="sonser-box"> -->
                        <!-- 循环生成每个传感器选项 -->
                        <template v-for="item in deviceTypes">
                            <span class="sensor-item">
                                <!-- Checkbox：绑定id到selectedIds -->
                                <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                                <!-- 数量输入框：选中时显示，未选中时隐藏 -->
                                <el-input-number v-if="selectedIds.includes(item.id)" v-model="counts[item.id]" :min="1"
                                    :max="10" size="small" style="width: 100px; margin-left: 10px;"></el-input-number>
                            </span>
                        </template>
                        <!-- </div> -->
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" class="dialog-btn cancel-btn">取消</el-button>
                <el-button type="primary" @click="handleSave" class="dialog-btn confirm-btn">保存</el-button>
            </div>
        </el-dialog>



        <!-- 修改模板信息弹窗 -->
        <el-dialog title="修改模板信息" :visible.sync="dialogVisibleEdit" width="500px" :close-on-click-modal="false"
            :destroy-on-close="true" custom-class="custom-dialog" @close="handleEditDialogClose">
            <el-form ref="deviceFormEdit" :model="deviceFormEdit" :rules="rulesTwo" label-width="120px"
                class="device-form">

                <!-- 模板类型（原有） -->
                <el-form-item label="设备类型" prop="type">
                    <el-select v-model="deviceFormEdit.categoryId" placeholder="请选择设备类型" @change="handleChangeEditName"
                        clearable class="form-select" :disabled="false">
                        <el-option v-for="item in deviceequipmentTypes" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>



                <el-form-item label="模板名称" prop="templateName">
                    <el-input v-model="deviceFormEdit.templateName" placeholder="请输入模板名称" maxlength="50" show-word-limit
                        class="form-input"></el-input>
                </el-form-item>




                <!-- 模板是否启用（原有） -->
                <el-form-item label="是否启用">
                    <el-radio v-model="radio" label="1">启用</el-radio>
                    <el-radio v-model="radio" label="0">禁用</el-radio>
                </el-form-item>

                <!-- 传感器（原有，无修改） -->
                <el-form-item label="传感器" required>
                    <el-checkbox-group v-model="selectedIds">
                        <template v-for="item in deviceTypes">
                            <span class="sensor-item">
                                <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                                <el-input-number v-if="selectedIds.includes(item.id)" v-model="counts[item.id]" :min="1"
                                    :max="10" size="small" style="width: 100px; margin-left: 10px;"></el-input-number>
                            </span>
                        </template>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleEdit = false" class="dialog-btn cancel-btn">取消</el-button>
                <el-button type="primary" @click="handleEditSave" class="dialog-btn confirm-btn">保存</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { templateList, addtemplate, delTemplate, templateOn, templateOff, templateSensorList } from '@/api/template'
import { sensorTypeList, categoryInfo } from '@/api/index'
export default {
    name: 'DeviceList',
    data() {
        return {
            selectedIds: [], // 绑定“选中的传感器id”的数组
            counts: {}, // 存储“每个传感器对应的数量”的对象
            radio: '1',
            searchKeyword: '',
            deviceStatus: '',
            deviceType: '',
            currentPage: 1,
            pageSize: 10,
            total: 0,
            dialogVisible: false,
            dialogVisibleEdit: false,
            searchKeywordCode: "",
            deviceequipmentTypes: [],
            // 模板表单数据
            deviceForm: {
                name: '',
                code: '',
                type: '',
                templateName: ''
            },
            deviceFormEdit: {
                templateName: '',
                enable: '',
                id: ''
            },
            devices: [],
            // 模板类型选项
            deviceTypes: [],
            // 表单验证规则
            rules: {
                type: [
                    { required: true, message: '请选择模板类型', trigger: 'change' }
                ],
                templateName: [
                    { required: true, message: '请输入模板名称', trigger: 'change' },
                    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                ]
            },
            rulesTwo: {

                enable: [
                    { required: true, message: '请输入模板编码', trigger: 'blur' },
                    { pattern: /^[A-Za-z0-9_-]+$/, message: '编码只能包含字母、数字、下划线和横线', trigger: 'blur' }
                ]

            },
        }
    },
    watch: {
        // 监听选中id的变化，初始化/清理数量
        selectedIds(newVal, oldVal) {
            // 新增选中项：初始化数量为1（确保响应式，用$set）
            newVal.forEach(id => {
                if (!this.counts[id]) {
                    this.$set(this.counts, id, 1);
                }
            });
            // 取消选中项：删除对应数量（可选，若需保留可注释）
            oldVal.forEach(id => {
                if (!newVal.includes(id)) {
                    this.$delete(this.counts, id);
                }
            });
        }
    },
    computed: {
        // 过滤模板列表 - 优化搜索逻辑
        filteredDevices() {
            // 如果没有搜索关键词，直接返回所有模板
            if (!this.searchKeyword) {
                return [...this.devices];
            }
            const keyword = this.searchKeyword.toLowerCase();
            return this.devices.filter(device => {
                // 确保模板名称和编码存在，避免undefined错误
                const nameMatch = device.name
                    ? device.name.toLowerCase().includes(keyword)
                    : false;
                const codeMatch = device.code
                    ? device.id.toLowerCase().includes(keyword)
                    : false;
                return nameMatch || codeMatch;
            })
        },
        // 分页处理
        pagedDevices() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            return this.filteredDevices.slice(startIndex, endIndex);
        }
    },
    mounted() {
        this.templateInfo();
        // this.categoryList(); // 提前加载模板类型
    },
    methods: {
        // 为表格行添加交替样式
        tableRowClassName({ row, rowIndex }) {
            return rowIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd';
        },


        generateSubmitData() {
            // 遍历选中的ID，映射成后端需要的格式
            this.equipmentTemplateSensorList = this.selectedIds.map((sensorTypeId, index) => {
                return {
                    sensorTypeId: Number(sensorTypeId), // 传感器ID
                    sensorNum: Number(this.counts[sensorTypeId]), // 对应的数量
                    sort: index + 1
                };
            });
        },

        handleChangeName(val) {

            // 根据ID匹配对应的名称
            const targetItem = this.deviceequipmentTypes.find(item => item.id === val);
            if (targetItem) {
                this.deviceForm.templateName = targetItem.name; // 存储名称用于回显
            }
        },


        handleChangeEditName(val) {
            const targetItem = this.deviceequipmentTypes.find(item => item.id === val);
            if (targetItem) {
                this.deviceFormEdit.templateName = targetItem.name; // 存储名称用于回显
            }
        },

        //新增模板信息
        async handleSave() {
            this.generateSubmitData();
            this.$refs.deviceForm.validate(async (valid) => {
                if (valid) {
                    let list = {
                        categoryId: Number(this.deviceForm.type),
                        templateName: this.deviceForm.templateName,
                        enable: Number(this.radio),
                        equipmentTemplateSensorList: this.equipmentTemplateSensorList
                    }

                    const res = await addtemplate(list)
                    if (res.code == "0000") {
                        this.$message.success('模板信息保存成功');
                        this.$nextTick(() => {
                            this.$refs.deviceForm.resetFields();
                        });
                        this.templateInfo()
                        this.dialogVisible = false;
                    } else {
                        this.$message.error('请完善模板信息并确保格式正确');
                        return false;
                    }
                }
            });
        },

        //删除模板
        handleDeleteDevice(id) {
            this.$confirm('确定要删除该模板吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await delTemplate(id)
                if (res.code == "0000") {
                    this.devices = this.devices.filter(device => device.id !== id)
                    this.$message.success('模板删除成功')
                    this.templateInfo()
                }
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },


        //启用模板
        handleViewOpen(id) {
            this.$confirm('确定启用该模板吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await templateOn(id)
                console.log("res")
                if (res.code == "0000") {
                    this.$message.success('设备模板启用成功')
                    this.templateInfo()
                }
            }).catch(() => {
                this.$message.info('已取消启用')
            })
        },

        //禁用模板
        handleViewdisable(id) {
            this.$confirm('确定禁用该模板吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await templateOff(id)
                console.log("res")
                if (res.code == "0000") {
                    this.$message.success('设备模板禁用成功')
                    this.templateInfo()
                }
            }).catch(() => {
                this.$message.info('已取消禁用')
            })
        },



        handleEditDialogClose() {
            this.selectedIds = [];  // 清空传感器选中状态
            this.counts = {};       // 清空传感器数量
            this.radio = "1";       // 重置启用状态为默认值
            // 重置表单（避免下次打开残留旧数据）
            if (this.$refs.deviceFormEdit) {
                this.$refs.deviceFormEdit.resetFields();
            }
        },


        //修改模板信息弹框
        // 点击“编辑”打开弹窗并回显数据
        async handleEditDevice(device) {
            try {
                // 1. 打开弹窗前先重置状态（避免残留旧数据）
                this.selectedIds = [];
                this.counts = {};

                // 2. 打开弹窗
                this.dialogVisibleEdit = true;

                // 3. 加载设备类型和传感器类型（确保下拉选项有数据）
                await Promise.all([this.categoryList(), this.sensorType()]);

                // 4. 回显模板基础信息（关键：正确赋值，删除错误的type赋值）
                this.deviceFormEdit = { ...device, categoryId: String(device.categoryId) }; // 此时已包含正确的type（设备类型ID）
                this.radio = String(device.enable); // 同步启用状态（转字符串匹配radio label）

                // 5. 调用接口获取模板关联的传感器配置（正确传参，假设接口需templateId）
                const sensorRes = await templateSensorList(device.id);
                // 注意：根据后端接口要求调整传参，若接口直接接收id，可改为 templateSensorList(device.id)

                // 6. 提取传感器配置列表（根据接口返回结构调整，确保路径正确）
                const sensorConfigList = sensorRes.result.equipmentTemplateSensorList || [];

                // 7. 回显传感器选中状态和数量（确保typeId转字符串，匹配checkbox的label）
                this.selectedIds = sensorConfigList.map(item => String(item.sensorTypeId));
                sensorConfigList.forEach(item => {
                    const typeIdStr = String(item.sensorTypeId);
                    this.$set(this.counts, typeIdStr, item.sensorNum); // 确保响应式
                });
            } catch (error) {
                console.error("编辑弹窗数据回显失败：", error); // 打印错误便于排查
                this.$message.error("加载模板详情失败，请重试");
                this.dialogVisibleEdit = false; // 加载失败关闭弹窗
            }
        },

        //点击保存修改模板信息
        async handleEditSave() {
            this.$refs.deviceFormEdit.validate(async (valid) => {
                if (valid) {
                    try {
                        // 1. 生成传感器配置提交格式（含 sort、数字类型转换）
                        this.generateSubmitData();

                        // 2. 构造编辑请求参数（与后端接口字段匹配，核心修改）
                        const editParams = {
                            id: this.deviceFormEdit.id,  // 模板 ID（必传，后端识别要修改的模板）
                            // templateName: this.deviceFormEdit.name,  // 模板名称（补全）
                            // code: this.deviceFormEdit.code,  // 模板编码（补全）
                            templateName: this.deviceFormEdit.templateName,
                            categoryId: Number(this.deviceFormEdit.categoryId),  // 设备类型（转数字）
                            enable: Number(this.radio),  // 启用状态（转数字）
                            equipmentTemplateSensorList: this.equipmentTemplateSensorList  // 传感器配置
                        };

                        // 3. 调用编辑接口（核心修改：替换为编辑接口，而非新增接口 addtemplate）
                        // 假设后端编辑接口为 editTemplate，需在 api/template.js 中导入
                        // console.log("editParams", editParams)
                        // return;
                        const res = await addtemplate(editParams);
                        // 4. 提交成功处理
                        if (res.code === "0000") {
                            this.$message.success("模板修改成功");
                            this.dialogVisibleEdit = false;  // 关闭弹窗
                            this.templateInfo();  // 刷新模板列表
                        } else {
                            this.$message.error(`修改失败：${res.msg || "未知错误"}`);
                        }
                    } catch (error) {
                        console.error("模板修改请求失败：", error);
                        this.$message.error("网络错误，修改失败，请重试");
                    }
                }
            });
        },


        //模板列表接口
        async templateInfo() {
            try {
                let list = {
                    "filter": [
                        {
                            "name": "templateName",
                            "value": this.searchKeyword,
                            "type": "LIKE"
                        }
                    ],
                    // name: this.searchKeyword,
                    current: this.currentPage,
                    size: this.pageSize,
                }
                const res = await templateList(list)
                this.devices = res.result.records || []; // 确保有默认空数组
                this.total = res.result.total;
            } catch (error) {
                console.error(error)
                this.devices = []; // 出错时重置为空数组
            }
        },


        //传感器类型接口
        async sensorType() {
            try {
                const res = await sensorTypeList({});
                this.deviceTypes = res.result.records;
                // 如果类型不一致（比如一个是数字，一个是字符串），统一类型
                this.deviceTypes = this.deviceTypes.map(item => ({
                    ...item,
                    id: String(item.id) // 统一转为字符串（或Number，看device.categooryId类型）
                }));
                this.deviceFormEdit.type = String(this.deviceFormEdit.type); // 同步类型
            } catch (error) {
                console.error('获取传感器类型失败：', error);
                this.$message.error('加载传感器类型失败，请重试');
            }
        },

        //设备类型接口
        async categoryList() {
            try {
              const param = {
                current : 1,
                size : 1000
              }
                const res = await categoryInfo(param);
                this.deviceequipmentTypes = res.result.records;
                // 如果类型不一致（比如一个是数字，一个是字符串），统一类型
                this.deviceequipmentTypes = this.deviceequipmentTypes.map(item => ({
                    ...item,
                    id: String(item.id) // 统一转为字符串（或Number，看device.categooryId类型）
                }));
                // this.deviceFormEdit.type = String(this.deviceFormEdit.type); // 同步类型
            } catch (error) {
                console.error('获取模板类型失败：', error);
                this.$message.error('加载模板类型失败，请重试');
            }
        },

        // 搜索处理 - 重置页码并重新加载数据
        handleSearch() {
            this.currentPage = 1; // 搜索时重置到第一页
            this.templateInfo()
        },

        handleSizeChange(val) {
            this.pageSize = val;
            // this.currentPage = 1; // 当页面大小改变时，重置到第一页
            this.templateInfo()
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.templateInfo()
        },

        getTypeName(type) {
            const typeMap = {
                temperature: '温度传感器',
                humidity: '湿度传感器',
                switch: '智能开关',
                smoke: '烟雾报警器'
            }
            return typeMap[type] || '未知类型'
        },

        getTypeTagType(type) {
            const typeMap = {
                temperature: 'primary',
                humidity: 'success',
                switch: 'warning',
                smoke: 'info'
            }
            return typeMap[type] || 'default'
        },

        handleAddDevice() {
            this.deviceForm = { type: '', templateName: '' }; // 重置表单
            this.dialogVisible = true;
            this.selectedIds = []
            this.sensorType()
            this.categoryList()
        },

        handleViewDetails(item) {
            this.$router.push({
                name: 'SensorList',
                query: {
                    id: item.id,
                    code: item.code,
                    name: item.name
                }
            })
        },
    }
}
</script>

<style scoped>
.sensor-item {
    display: flex;
    align-items: center;
    gap: 12px;
    /* Checkbox与数量控件的间距 */
    margin-bottom: 8px;
    /* 上下项间距 */
}

/* 调整数量控件宽度 */
.count-input {
    width: 120px;
}

/* 全局样式 */
.device-list-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

/* 页面标题 */
.page-header {
    margin-bottom: 24px;
}

.page-header h2 {
    font-size: 22px;
    color: #1f2937;
    margin-bottom: 8px;
    font-weight: 600;
}

.page-header p {
    font-size: 14px;
    color: #6b7280;
}

/* 主卡片样式 */
.main-card {
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: none;
    overflow: hidden;
    transition: all 0.3s ease;
}

.main-card:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}


.header-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
}

.add-btn {
    transition: all 0.2s ease;
}

.add-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

/* 搜索区域 */
.filter-bar {
    display: flex;
    margin: 20px;
    align-items: center;
}

.search-input {
    width: 300px;
    height: 40px;
    border-radius: 6px;
    transition: all 0.3s ease;
}

.search-input:focus {
    border-color: #1890ff;
    box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
}

/* 表格样式 */
.device-table {
    margin: 0 20px;
    border-radius: 6px;
    overflow: hidden;
}

::v-deep .el-table th {
    background-color: #f7f8fa;
    font-weight: 500;
    color: #4b5563;
    padding: 12px 0;
}

::v-deep .el-table td {
    padding: 12px 0;
}

.table-row-even {
    background-color: #fff;
}

.table-row-odd {
    background-color: #fafafa;
}

::v-deep .el-table__row:hover>td {
    background-color: #f0f7ff !important;
}

::v-deep .el-table__current-row>td {
    background-color: #e6f7ff !important;
}

/* 操作按钮样式 */
.operation-btn {
    padding: 4px 8px;
    margin: 0 4px;
    border-radius: 4px;
    transition: all 0.2s ease;
}

.view-btn {
    color: #1890ff;
}

.view-btn:hover {
    background-color: rgba(24, 144, 255, 0.1);
}

.edit-btn {
    color: #52c41a;
}

.edit-btn:hover {
    background-color: rgba(82, 196, 26, 0.1);
}

.delete-btn {
    color: #ff4d4f;
}

.delete-btn:hover {
    background-color: rgba(255, 77, 79, 0.1);
}

/* 分页样式 */
.pagination-container {
    margin: 20px;
    padding-top: 15px;
    border-top: 1px solid #f0f2f5;
    text-align: right;
}

::v-deep .el-pagination {
    font-size: 14px;
}

::v-deep .el-pagination button,
::v-deep .el-pagination span:not([class*='suffix']) {
    height: 32px;
    line-height: 32px;
    min-width: 32px;
    border-radius: 4px;
}

::v-deep .el-pagination .el-pager li {
    margin: 0 3px;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    line-height: 32px;
}

::v-deep .el-pagination .el-pager li.active {
    background-color: #1890ff;
    color: #fff;
}

/* 表单样式 */
.device-form {
    margin-top: 15px;
}

.form-input,
.form-select {
    width: 100%;
    border-radius: 6px;
    transition: all 0.3s ease;
}

.form-input:focus,
.form-select:focus {
    border-color: #1890ff;
    box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
}

/* 弹窗样式 */
::v-deep .custom-dialog {
    border-radius: 12px;
    overflow: hidden;
}

::v-deep .custom-dialog .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #f0f2f5;
    background-color: #f7f8fa;
}

::v-deep .custom-dialog .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
}

::v-deep .custom-dialog .el-dialog__body {
    padding: 20px;
}

::v-deep .custom-dialog .el-dialog__footer {
    padding: 12px 20px;
    border-top: 1px solid #f0f2f5;
}

.sonser-box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

::v-deep .el-checkbox__label {
    padding-left: 6px !important;
}

::v-deep .el-checkbox {
    padding-right: 10px;
}

/* 弹窗按钮 */
.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.dialog-btn {
    padding: 8px 16px;
    border-radius: 6px;
    transition: all 0.2s ease;
}

.cancel-btn {
    background-color: #f5f5f5;
    color: #4b5563;
    border-color: #e0e0e0;
}

.cancel-btn:hover {
    background-color: #e9e9e9;
    color: #374151;
}

.confirm-btn {
    background-color: #1890ff;
    border-color: #1890ff;
}

.confirm-btn:hover {
    background-color: #0f7ae5;
    border-color: #0f7ae5;
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

/* 优化表单项间距 */
::v-deep .el-form-item {
    margin-bottom: 20px;
}

/* 响应式适配 */
@media (max-width: 768px) {
    .device-list-container {
        padding: 10px;
    }

    .search-input {
        width: 100%;
    }

    .header-actions {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .pagination-container {
        text-align: center;
    }

    ::v-deep .el-table {
        font-size: 13px;
    }

    ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
    }

    .operation-btn {
        padding: 2px 6px;
        font-size: 12px;
    }
}
</style>
